import ElearningPost from '@/components/elearning-post/ElearningPost.vue'
import vSelect from 'vue-select'
import { BPaginationNav, BPagination } from 'bootstrap-vue'
import fetchItems from '@/scripts/vue/api-axios'
import VueScrollTo from 'vue-scrollto'

const categoryId = typeof window.category_id === "undefined" ? 1011 : window.category_id
const perPageInitial = typeof window.perPageInitial === "undefined" ? 3 : window.perPageInitial

const eventsRecordsListConfig = {
  components: {
    ElearningPost,
    vSelect,
    BPaginationNav,
    BPagination
  },
  mounted() {
    // start loader
    this.$Progress.start();

    // get videos
    fetchItems(`/yiifeventsrecords?categoryId=${ categoryId }`)
      .then((videos) => {

        // sort video types
        this.videosEvents = videos.filter(video => { 
            return video.type === 'Events'
        });

      })
      .then(() => {
          
        // get filters
        fetchItems(`/yiifcategory/eventsrecords?categoryId=${ categoryId }`)
          .then((filters) => {
            this.scrollTo('body', 0);

            // sort filter types
            this.EventsCategories = filters.filter(filter => {
                return filter.type === 'Events'
            });
            

            // set the "Show All" option
            this.setShowAllOptions();

            // finish loader
            this.$Progress.finish();

            // category attribute from url
            const categoryEventsParam = parseInt(window.utils.getQueryStringParameter('eventsCategory'));
            if ( categoryEventsParam )
            {
              const currentEventsCategory = this.EventsCategories.filter(option => {
                return option.id == categoryEventsParam
              });

              this.EventsSelectedCategory = currentEventsCategory[0].id;
            }

            // pagination attribute from url
            const pageEventsParam = window.utils.getQueryStringParameter('eventsPage');
            if ( pageEventsParam )
            {
              this.EventscurrentPage = pageEventsParam;
            }

            // per page attribute from url
            const perPageEventsParam = window.utils.getQueryStringParameter('eventsPerPage');
            if ( perPageEventsParam )
            {
              this.EventsPerPage = parseInt(perPageEventsParam);
            }

            // scrollTo attribute from url
            const scrollToParam = window.utils.getQueryStringParameter('scrollTo');
            if ( scrollToParam == 'Events' )
            {
              this.scrollToEvents();
              window.utils.setQueryStringParameter('scrollTo', false);
            }


          })

      });

  },
  data: () => ({
    videosEvents: [],

    EventsCategories: [],

    EventsSelectedCategory: null,

    EventscurrentPage: 1,

    EventsPerPage: perPageInitial,

    scrollerIsScrolling: false
  }),
  computed: {
    EventsItemsForList(){
      return this.EventsFilteredItems
      .slice(
        // slice per page
        (this.EventscurrentPage - 1) * this.EventsPerPage,
        this.EventscurrentPage * this.EventsPerPage,
      );
    },

    EventsFilteredItems() {
        return this.videosEvents.filter(video => {
            if ( !this.EventsSelectedCategory ) return true;
            return video.type_id == this.EventsSelectedCategory
        });
    },

    EventsRows(){
      return this.EventsFilteredItems.length
    }
  },
  methods: {
      setShowAllOptions(){

        // EventsCategories Show all option
        if ( this.$refs.EventsCategorySelect?.placeholder )
        {
            // get placeholder from ref select
            const placeholder = this.$refs.EventsCategorySelect.placeholder;

            // fill clear option, append it as first element and select by default (id 0 is what makes it show all categories)
            const clearOption = {
                id: 0,
                name: placeholder,
                type: 'E'
            };

            this.EventsCategories.unshift(clearOption);
            this.EventsSelectedCategory = 0;
        }
      },
      scrollTo(target, duration, offset) {
        // if not scrolling already
        if ( !this.scrollerIsScrolling )
        {
          // scroll to target with desired duration
          VueScrollTo.scrollTo(target, {
            duration: duration,
            offset: offset,
            onStart: () => {
              // set scrolling variable
              this.scrollerIsScrolling = true;
            },
            onDone: () => {
              // unset scrolling variable
              this.scrollerIsScrolling = false;
            }
          });
        }
      },
      scrollToEvents(remember = false){
        this.scrollTo('#videosEvents', 500, -100);

        if ( remember )
        {
          window.utils.setQueryStringParameter('scrollTo', 'Events');
        }
      }
  },
  watch: {
    EventsPerPage: function(newValue, oldValue) {
      this.scrollToEvents();

      if ( newValue != oldValue )
      {
        window.utils.setQueryStringParameter('eventsPerPage', this.EventsPerPage);
      }
    },

    EventscurrentPage: function(newValue, oldValue) {
      this.scrollToEvents();

      // change query string after changing pagination
      if ( newValue != oldValue )
      {
        window.utils.setQueryStringParameter('eventsPage', this.EventscurrentPage);
      }
    },

    EventsSelectedCategory: function (newValue, oldValue) {
      if ( oldValue != newValue && oldValue != null ) {
        this.EventscurrentPage = 1;
      }

      if ( newValue )
      {
        window.utils.setQueryStringParameter('eventsCategory', newValue);
      }
      else
      {
        window.utils.setQueryStringParameter('eventsCategory', 0);
      }
    }
  }
}

export default eventsRecordsListConfig